module.exports = __webpack_public_path__ + "static/img/skyserver.8eb01b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/skyserver.png
// module id = 7EyP
// module chunks = 1